module.exports = __webpack_public_path__ + "static/media/adidas.c94e5bb1.png";